import {
  H_06,
  HERO_DEFAULTS,
  hideH06Props,
} from "@stadium/shared/src/helpers/plasmic/static-slices";

export const H06_PLASMIC_PROPS = {
  h06Heading: {
    type: "string",
    defaultValue: HERO_DEFAULTS[H_06].heading,
    description: "Main hero heading (H06 only)",
    hidden: hideH06Props,
  },
  h06Description: {
    type: "string",
    defaultValue: HERO_DEFAULTS[H_06].description,
    description: "Hero description text (H06 only)",
    hidden: hideH06Props,
  },
  h06PrimaryButtonText: {
    type: "string",
    defaultValue: HERO_DEFAULTS[H_06].primaryButtonText,
    description: "Primary button text (H06 only)",
    hidden: hideH06Props,
  },
  h06PrimaryButtonUrl: {
    type: "string",
    defaultValue: HERO_DEFAULTS[H_06].primaryButtonUrl,
    description: "Primary button URL (H06 only)",
    hidden: hideH06Props,
  },
  h06SecondaryButtonText: {
    type: "string",
    defaultValue: HERO_DEFAULTS[H_06].secondaryButtonText,
    description: "Secondary button text (H06 only)",
    hidden: hideH06Props,
  },
  h06SecondaryButtonUrl: {
    type: "string",
    defaultValue: HERO_DEFAULTS[H_06].secondaryButtonUrl,
    description: "Secondary button URL (H06 only)",
    hidden: hideH06Props,
  },
  h06HeroImage: {
    type: "imageUrl",
    defaultValue: HERO_DEFAULTS[H_06].heroImage,
    description: "Hero image (H06 only)",
    hidden: hideH06Props,
  },
  h06HeroImageAlt: {
    type: "string",
    defaultValue: HERO_DEFAULTS[H_06].heroImageAlt,
    description: "Hero image alt text (H06 only)",
    hidden: hideH06Props,
  },
  className: {
    type: "string",
    defaultValue: "",
  },
};
